// src/features/dashboard/components/RecentOrdersTable.tsx
import { ArrowUpLeft } from 'lucide-react';
import { GlassCard } from '../../../app/components/ui/GlassCard';
import { TableRowSkeleton } from './ui/Skeleton';
import { StatusBadge } from './StatusBadge';
import { formatToman } from '../utils/formatters';
import type { RecentOrder } from '../types/dashboard.types';

interface RecentOrdersTableProps {
  orders: RecentOrder[];
  isInitialLoading: boolean;
}

export function RecentOrdersTable({ orders, isInitialLoading }: RecentOrdersTableProps) {
  return (
    <GlassCard noPadding className="vania-orders-card" data-animate="fade-in">
      <div className="vania-orders-card__header flex items-center justify-between p-5 sm:p-6 pb-4">
        <h3 className="vania-panel-title">سفارش‌های اخیر</h3>
        <button type="button" className="vania-link-button">
          مشاهده همه
          <ArrowUpLeft size={14} strokeWidth={2.5} />
        </button>
      </div>

      {/* header row (desktop only) */}
      <div className="vania-orders-table-head hidden sm:grid grid-cols-[1.6fr_1.6fr_1fr_1fr_0.9fr] gap-4 px-6 py-2.5 text-[11px] font-semibold text-[var(--vania-text-tertiary,#6b7280)]">
        <span>مشتری</span>
        <span>محصول</span>
        <span>مبلغ</span>
        <span>وضعیت</span>
        <span>زمان</span>
      </div>

      <div className="divide-y divide-[var(--vania-border-glass,rgba(255,255,255,0.06))]">
        {isInitialLoading
          ? Array.from({ length: 5 }).map((_, i) => <TableRowSkeleton key={i} />)
          : orders.map((order) => (
              <div
                key={order.id}
                className="vania-table-row grid grid-cols-2 sm:grid-cols-[1.6fr_1.6fr_1fr_1fr_0.9fr] gap-2 sm:gap-4 items-center px-5 sm:px-6 py-3.5"
              >
                <div className="flex items-center gap-2.5 col-span-2 sm:col-span-1">
                  <img
                    src={order.customerAvatarUrl}
                    alt={order.customerName}
                    className="vania-order-avatar h-8 w-8 rounded-full bg-[var(--vania-surface-2,rgba(255,255,255,0.04))]"
                  />
                  <span className="text-sm font-medium text-[var(--vania-text-primary,#f5f6fa)] truncate">
                    {order.customerName}
                  </span>
                </div>

                <span className="text-sm text-[var(--vania-text-secondary,#a3aab8)] truncate">
                  {order.product}
                </span>

                <span className="text-sm font-semibold tabular-nums text-[var(--vania-text-primary,#f5f6fa)]">
                  {formatToman(order.amount)}
                </span>

                <span>
                  <StatusBadge status={order.status} />
                </span>

                <span className="text-xs text-[var(--vania-text-tertiary,#6b7280)]">
                  {order.time}
                </span>
              </div>
            ))}
      </div>
    </GlassCard>
  );
}
